/**
 * Typed PostHog event name constants shared across all Attik services.
 *
 * Keys are camelCase; values are the exact strings sent to PostHog.
 * Existing backend events use space-separated strings (preserved for
 * backward compatibility with live dashboards and funnels). New events
 * should use snake_case.
 */
export const EVENTS = {
  // ── Company / Auth ──────────────────────────────────────────────────────
  companySignedUp: 'company signed up',
  userSignedUp: 'user_signed_up',
  loginMagicLinkSent: 'login_magic_link_sent',
  loginGoogleClicked: 'login_google_clicked',
  userGoogleLogin: 'user_google_login',

  // ── Inspections ─────────────────────────────────────────────────────────
  inspectionBooked: 'inspection booked',
  inspectionCreated: 'inspection created',
  inspectionConfirmed: 'inspection confirmed',
  inspectionCancelled: 'inspection cancelled',

  // ── Payments ────────────────────────────────────────────────────────────
  paymentCreated: 'payment created',
  paymentRefunded: 'payment refunded',
  paymentSubmitted: 'payment_submitted',
  paymentCompleted: 'payment_completed',
  paymentFailed: 'payment_failed',
  finixPaymentSettled: 'finix payment settled',

  // ── Quotes ──────────────────────────────────────────────────────────────
  quoteCreated: 'quote created',
  quoteAcceptanceStarted: 'quote_acceptance_started',
  quoteAccepted: 'quote_accepted',

  // ── Scheduler ───────────────────────────────────────────────────────────
  schedulerStepViewed: 'scheduler_step_viewed',
  schedulerServiceSelected: 'scheduler_service_selected',
  schedulerSlotSelected: 'scheduler_slot_selected',
  schedulerQuoteSent: 'scheduler_quote_sent',
  schedulerJobBooked: 'scheduler_job_booked',
  schedulerBookingFailed: 'scheduler_booking_failed',

  // ── Repair / Contractor ─────────────────────────────────────────────────
  repairListCreated: 'repair list created',
  repairQuoteRequested: 'repair_quote_requested',
  contractorQuoteSubmitted: 'contractor_quote_submitted',

  // ── Reports ─────────────────────────────────────────────────────────────
  reportFeedbackClicked: 'report_feedback_clicked',
  reportFeedbackBannerDismissed: 'report_feedback_banner_dismissed',

  // ── Business ────────────────────────────────────────────────────────────
  chargeCreated: 'charge created',
  inviteSent: 'invite sent',
  subscriptionCreated: 'subscription created',

  // ── Observability (internal telemetry) ──────────────────────────────────
  dashboardLoadSummary: 'dashboard_load_summary',
  dashboardApiRequest: 'dashboard_api_request',
  frontendLog: 'frontend_log',
  messageCaptured: 'message_captured',
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];
